export const headers = [
  'Имя',
  'Телефон',
  'Город',
  'Адрес',
  'Приложение',
];
